import { Group, Text } from '@mantine/core';

export default function NotificationDetailRow({ label, value }: { label: string; value: string }) {
  return (
    <Group gap="xs" wrap="nowrap" align="baseline">
      <Text size="xs" fw={600} c="gray.6" w={84} style={{ flexShrink: 0 }}>
        {label}
      </Text>
      <Text size="xs" c="gray.8">
        {value}
      </Text>
    </Group>
  );
}
